"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function uint8ArrayToBlob(array, type) {
    return new Blob([array], { type: type });
}
exports.uint8ArrayToBlob = uint8ArrayToBlob;
exports.default = uint8ArrayToBlob;
//# sourceMappingURL=uint8ArrayToBlob.js.map